import { gql } from '@utils/gpl-dedup';

export const listTypeFragment = gql`
  fragment listType on ListType {
    id
    name
    has_description
  }
`;
